module.exports = __webpack_public_path__ + "themes/non-default/addeparStep2PortfolioPrefix.ac16e54df22ca41dbb62ec3ab137c717.png";